class RecoverForm extends AjaxForm {
    constructor() {
        super();
        this.email = this.querySelector('[name="email"]');
        this.errorMessage = this.querySelector("#recover-email-error"); // Visible error message
        this.errorSummary = this.querySelector("#error-summary"); // Screen reader alert
        this.submit = this.querySelector("button.reset-button");
    }

    connectedCallback() {
        if (this.submit) {
            this.submit.addEventListener("click", (e) => this.onSubmit(e));
        } else {
            console.error("Submit button not found");
        }

      
      
    }

    hideMailError() {
        if (this.errorMessage) {
            this.email.removeAttribute("aria-invalid");
            this.errorMessage.textContent = ''; // Clear visible error message
        }
        if (this.errorSummary) {
            this.errorSummary.innerHTML = '';  // Clear screen reader alert
            this.errorSummary.classList.add('visually-hidden');
        }
    }

    showMailError(message) {
        // Set visible error message
        if (this.errorMessage) {
            this.errorMessage.textContent = message; 
            this.email.setAttribute("aria-invalid", "true");
        }

        // Temporarily show the alert to screen readers
        if (this.errorSummary) {
            this.errorSummary.innerHTML = `
                <ul>
                    <li>${message}</li>
                </ul>
            `;
            this.errorSummary.classList.remove('visually-hidden');  // Temporarily remove the visually-hidden class for screen readers
            this.errorSummary.setAttribute('role', 'alert');
            this.errorSummary.setAttribute('aria-live', 'assertive');
            this.errorSummary.focus(); // Focus the error message for screen readers

            // Reapply the visually-hidden class after 1 second
            setTimeout(() => {
                this.errorSummary.classList.add('visually-hidden');
            }, 10); // Keep visible for 5 seconds for screen readers
        }
    }

    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    onSubmit(e) {
        e.preventDefault();
        this.hideMailError();

        let isValid = true;

        // Email validation
        if (!this.email.value.trim()) {
            isValid = false;
            const message = 'Please enter an email address.';
            this.showMailError(message); 
        } else if (!this.isValidEmail(this.email.value.trim())) {
            isValid = false;
            const message = 'Please enter a valid email address.';
            this.showMailError(message); 
        }

        if (isValid) {
            this.querySelector('form').submit();
        }
    }
}

customElements.define("reset-password", RecoverForm);